export const getCurrentPlanName = (currentPlan) => {
  if (!currentPlan) return "Free";
  return currentPlan.charAt(0).toUpperCase() + currentPlan.slice(1);
};

export const getAnimationVariants = () => ({
  pageVariants: {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, staggerChildren: 0.1 }
    }
  },
  itemVariants: {
    hidden: { opacity: 0, scale: 0.95 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.4 } }
  }
});
